import React from 'react';

type State = {
  hasError: boolean;
  message: string;
};

export class AppErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = {
    hasError: false,
    message: '',
  };

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : String(error),
    };
  }

  componentDidCatch(error: unknown) {
    console.error('Elite Coach Cloud runtime error:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="fatal-runtime-screen">
          <section className="metal-card fatal-runtime-card">
            <p className="eyebrow">ELITE COACH CLOUD · RECOVERY</p>
            <h1>Application recovery</h1>
            <p>
              A runtime error was intercepted instead of leaving the application on a blank screen.
            </p>
            <code>{this.state.message || 'Unknown runtime error'}</code>
            <button onClick={() => window.location.reload()}>Reload application</button>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
